import { useLocation } from "react-router-dom";
import PublicNavbar from "@/components/PublicNavbar";
import PublicFooter from "@/components/PublicFooter";
import { clientFromSearch } from "@/lib/guideClient";

/**
 * The marketing site is Studio Quiet dark on purpose and never takes the
 * theme toggle — it is a brand surface with no signed-in reader. `data-theme`
 * pins the token layer dark for this subtree so a light-mode instructor who
 * opens /pricing still sees a coherent page rather than dark ink on black.
 *
 * A page opened from the iOS app (`?client=ios`, see lib/guideClient) gets the
 * app's navbar and footer: no pricing, sign-in or product links, since links
 * to another purchase method are not allowed on every storefront, and links
 * to the pages that have an iOS mode carry `client=ios` so the next page keeps
 * it. The mode is read from the URL here, not passed in, so no page can forget.
 */
const PublicLayout = ({ children }) => {
  const client = clientFromSearch(useLocation().search);
  // The markup keeps its original indentation: re-indenting it would re-add
  // its legacy colour literals as "new" lines to the brand lint.
  return (
  <div
    data-theme="dark"
    className="min-h-screen text-white overflow-x-hidden"
    style={{
      background:
        "radial-gradient(ellipse at 50% 0%, rgba(244,207,8,0.055) 0%, rgba(244,207,8,0.015) 40%, transparent 70%) no-repeat, #09090b",
    }}
  >
    <PublicNavbar client={client} />
    {children}
    <PublicFooter client={client} />
  </div>
  );
};

export default PublicLayout;
